import { Button } from '@/components/ui/button';
import { MOTION } from '@/utils';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { useRef } from 'react';

export default function Cta() {
  const refs = {
    section: useRef<HTMLElement>(null),
    title: useRef(null),
    button: useRef<HTMLDivElement>(null),
  };

  useGSAP(
    () => {
      if (!refs.section.current) return;
      const splitTitle = new SplitText(refs.title.current, { type: 'lines', mask: 'lines' });
      gsap.set(refs.button.current, { autoAlpha: 0, y: 8 });

      const tl = gsap.timeline({
        defaults: { duration: MOTION.durationMd, ease: MOTION.ease },
        scrollTrigger: {
          trigger: refs.section.current,
          start: 'top 70%',
          toggleActions: 'play none none reverse',
        },
      });

      tl.from(splitTitle.lines, {
        yPercent: MOTION.yPercent,
        stagger: MOTION.staggerLines,
      }).to(refs.button.current, { autoAlpha: 1, y: 0, duration: MOTION.durationSm }, '<+0.2');

      return () => {
        splitTitle.revert();
      };
    },
    { scope: refs.section },
  );

  return (
    <section ref={refs.section} className="max-width-blue-section" id="tarif-cta">
      <div className="flex flex-col items-center gap-6 text-center">
        <h2 ref={refs.title} className="w-fit max-w-2xl">
          Prêt à simplifier la gestion de votre cabinet ?
        </h2>
        <div ref={refs.button}>
          <Button href="/contact" variant="fill">
            Demandez une démo
          </Button>
        </div>
        <p className="text-dark-blue/35 text-xs">
          Tous les prix s&apos;entendent hors taxes. Sans engagement.
        </p>
      </div>
    </section>
  );
}
